import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var CatalogueFilled = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C13.045 22 14.052 21.8371 15 21.5391V20.4766V19.4102V18.3145C14.089 18.7485 13.074 19 12 19C8.141 19 5 15.86 5 12C5 8.14 8.141 5 12 5C12.196 5 12.39 5.0143 12.582 5.0293C12.802 4.3943 13.0642 3.7553 13.4102 3.1543C13.5962 2.8323 13.7985 2.52152 14.0215 2.22852C13.3665 2.09352 12.696 2 12 2ZM18 2C17.2495 2 16.6204 2.37239 16.1445 2.82227C15.6686 3.27214 15.3002 3.82432 14.9922 4.41602C14.3762 5.5994 14 6.90133 14 8C14 9.85034 15.2842 11.4056 17 11.8555V22H19V11.8555C20.7158 11.4056 22 9.85034 22 8C22 6.90133 21.6238 5.5994 21.0078 4.41602C20.6998 3.82432 20.3314 3.27214 19.8555 2.82227C19.3796 2.37239 18.7505 2 18 2ZM12 7C9.243 7 7 9.243 7 12C7 14.757 9.243 17 12 17C13.13 17 14.162 16.6096 15 15.9746V13.1816C13.178 12.1306 12 10.173 12 8C12 7.697 12.0311 7.35781 12.0801 7.00781C12.0531 7.00781 12.028 7 12 7Z",
    fill: fill
  }));
};
export { CatalogueFilled as default };
//# sourceMappingURL=CatalogueFilled.js.map
